import { render, staticRenderFns } from "./FeedbackAdd.vue?vue&type=template&id=700482a4&"
import script from "./FeedbackAdd.vue?vue&type=script&lang=js&"
export * from "./FeedbackAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports